import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  @font-face {
    src: url("/fonts/Quicksand-Bold.ttf");
    font-family: 'Quicksand';
    font-weight: bold;
  }
  @font-face {
    src: url("/fonts/Quicksand-Medium.ttf");
    font-family: 'Quicksand';
    font-weight: 500;
  }
  @font-face {
    src: url("/fonts/Quicksand-Light.ttf");
    font-family: 'Quicksand';
    font-weight: light;
  }
  @font-face {
    src: url("/fonts/Quicksand-Regular.ttf");
    font-family: 'Quicksand';
  }
  html,
  body {
    height: 100%;
    width: 100%;
    font-size: 14px;
  }

  body {
    font-family: 'Quicksand', Helvetica, Arial, sans-serif;
  }

  #root {
    min-height: 100%;
    min-width: 100%;
  }

  p,
  label {
    font-family: 'Quicksand', Helvetica, Arial, sans-serif;
  }

  input, select {
    font-family: inherit;
    font-size: inherit;
  }
`;
